import React, { useMemo } from 'react'
import View from './View'
import { MessageAuthor } from 'dealer-types'

type AvatarVariant = 'OfferMessage' | 'ConversationMessage'

interface Props {
  type: MessageAuthor
  imgSrc?: string | null
  variant?: AvatarVariant
}

const Avatar = ({ type, imgSrc, variant = 'OfferMessage' }: Props): JSX.Element => {
  const avatarImage = useMemo(() => {
    if (type === 'dealer') {
      if (typeof imgSrc === 'string' && imgSrc.length > 0) {
        return imgSrc
      }
      if (variant === 'OfferMessage') {
        return '/assets/images/example_dealer.png'
      }
      return '/assets/images/empty_avatar.png'
    }
    return '/assets/images/logo_estimoto.png'
  }, [type, imgSrc, variant])

  const borderWidthStyles = type === 'dealer' ? 'border-1' : 'border-0'
  const borderColorStyles = variant === 'OfferMessage' ? 'border-white' : 'border-groupBlue'
  return (
    <View className={`flex justify-center items-top ${borderColorStyles} ${borderWidthStyles}`}>
      <img src={avatarImage} className="w-9 h-8 rounded-4 object-cover border-white border" />
    </View>
  )
}

export default Avatar
